module.exports = __webpack_public_path__ + "static/certificate22x-f60b2177d9c8ae44428c211730bc3f52.jpg";